module.exports = __webpack_public_path__ + "DejaVuSansMono-BoldOblique.ca84e5775e93e87fbeda.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/external_css/kendo-ui/fonts/DejaVu/DejaVuSansMono-BoldOblique.ttf?v=1.1
// module id = ../../../../../external_css/kendo-ui/fonts/DejaVu/DejaVuSansMono-BoldOblique.ttf?v=1.1
// module chunks = styles